var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fixed-menu" },
    [
      _c("md-toolbar", { staticClass: "md-primary" }, [
        _c(
          "div",
          { staticClass: "md-toolbar-row" },
          [
            _c(
              "div",
              { staticClass: "md-toolbar-section-start md-primary" },
              [
                _c(
                  "md-menu",
                  { attrs: { "md-size": "auto", "md-align-trigger": "" } },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button md-primary",
                        attrs: { "md-menu-trigger": "" }
                      },
                      [_c("md-icon", [_vm._v("menu")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "md-menu-content",
                      { staticClass: "main-menu-wrapper" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/" } },
                          [
                            _c(
                              "md-menu-item",
                              [
                                _c("span", [_vm._v("Home")]),
                                _vm._v(" "),
                                _c("md-icon", [_vm._v("home")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/news" } },
                          [
                            _c(
                              "md-menu-item",
                              [
                                _c("span", [_vm._v("Neuigkeiten")]),
                                _vm._v(" "),
                                _c("md-icon", [_vm._v("message")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/businessmodel" } },
                          [
                            _c(
                              "md-menu-item",
                              [
                                _c("span", [_vm._v("Geschäftsmodellaspekte")]),
                                _vm._v(" "),
                                _c("md-icon", [_vm._v("apps")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/technology" } },
                          [
                            _c("md-menu-item", [
                              _c("span", [_vm._v("Technologien")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "small-icon",
                                attrs: {
                                  src: require("../../../assets/landingIcons_small/werner_tech_icon_small.svg")
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/offer" } },
                          [
                            _c("md-menu-item", [
                              _c("span", [_vm._v("Digitale Angebote")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "small-icon",
                                attrs: {
                                  src: require("../../../assets/landingIcons_small/werner_offers_icon_small.svg")
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/kitrainer" } },
                          [
                            _c("md-menu-item", [
                              _c("span", [_vm._v("KI-Trainer")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "small-icon",
                                attrs: {
                                  src: require("../../../assets/landingIcons_small/werner_ki_search_icon_small.svg")
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/referenceproject" } },
                          [
                            _c("md-menu-item", [
                              _c("span", [_vm._v("Referenzprojekte")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "small-icon",
                                attrs: {
                                  src: require("../../../assets/landingIcons_small/werner_ref_icon_small.svg")
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/search/event" } },
                          [
                            _c("md-menu-item", [
                              _c("span", [_vm._v("Veranstaltungen")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "small-icon",
                                attrs: {
                                  src: require("../../../assets/landingIcons_small/werner_event_icon_small.svg")
                                }
                              })
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.loggedIn
                  ? _c("div", { staticStyle: { "margin-left": "30px" } }, [
                      _vm._v(_vm._s(_vm.activeView))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/" } }, [
              _c("img", {
                staticStyle: { height: "50px" },
                attrs: {
                  src: require("../../../assets/werner-logo-hell-no-subtitle.svg")
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "md-toolbar-section-end" }, [
              _vm.loggedIn
                ? _c(
                    "div",
                    [
                      _c(
                        "md-menu",
                        {
                          attrs: {
                            "md-size": "auto",
                            "md-direction": "bottom-start"
                          }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button md-primary",
                              attrs: { "md-menu-trigger": "" }
                            },
                            [_c("md-icon", [_vm._v("person")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-menu-content",
                            [
                              _vm.trainer
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "md-menu-item",
                                        {
                                          attrs: {
                                            href: "https://werner.dfki.de/ki/"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("KI-Trainer-Profil")
                                          ]),
                                          _vm._v(" "),
                                          _c("md-icon", [_vm._v("people")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "router-link",
                                    { attrs: { to: "/profile/create" } },
                                    [
                                      _c(
                                        "md-menu-item",
                                        [
                                          _c("span", [
                                            _vm._v("Unternehmensprofil")
                                          ]),
                                          _vm._v(" "),
                                          _c("md-icon", [
                                            _vm._v("location_city")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                { attrs: { to: "/bm/menu" } },
                                [
                                  _c(
                                    "md-menu-item",
                                    [
                                      _c("span", [
                                        _vm._v("Meine Geschäftsmodelle")
                                      ]),
                                      _vm._v(" "),
                                      _c("md-icon", [_vm._v("apps")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                { attrs: { to: "/profile/partners" } },
                                [
                                  _c(
                                    "md-menu-item",
                                    [
                                      _c("span", [
                                        _vm._v("Meine Projektpartner")
                                      ]),
                                      _vm._v(" "),
                                      _c("md-icon", [_vm._v("people")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                { attrs: { to: "/settings" } },
                                [
                                  _c(
                                    "md-menu-item",
                                    [
                                      _c("span", [_vm._v("Einstellungen")]),
                                      _vm._v(" "),
                                      _c("md-icon", [_vm._v("settings")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-menu-item",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.writeFeedback = true
                                    }
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Feedback")]),
                                  _vm._v(" "),
                                  _c("md-icon", [_vm._v("feedback")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                { attrs: { to: "/logout" } },
                                [
                                  _c(
                                    "md-menu-item",
                                    [
                                      _c("span", [_vm._v("Log out")]),
                                      _vm._v(" "),
                                      _c("md-icon", [_vm._v("logout")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  !_vm.loggedIn
                    ? _c("md-button", { attrs: { to: "/register" } }, [
                        _vm._v("Registrieren")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loggedIn
                    ? _c("md-button", { attrs: { to: "/login" } }, [
                        _vm._v("Anmelden")
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticStyle: { width: "700px" },
          attrs: { "md-active": _vm.writeFeedback },
          on: {
            "update:mdActive": function($event) {
              _vm.writeFeedback = $event
            },
            "update:md-active": function($event) {
              _vm.writeFeedback = $event
            }
          }
        },
        [
          _c("md-dialog-title", [
            _vm._v("Teilen Sie Ihre Erfahrungen mit WERNER")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-center" },
            [
              _c("div", {
                staticClass:
                  "md-layout-item md-size-25 md-medium-size-0 md-small-size-10 md-xsmall-size-0"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-primary md-raised",
                      on: {
                        click: function($event) {
                          _vm.thumb = "good"
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("thumb_up_alt")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-primary md-raised",
                      on: {
                        click: function($event) {
                          _vm.thumb = "bad"
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("thumb_down_alt")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "md-layout-item md-size-25 md-medium-size-0 md-small-size-10 md-xsmall-size-0"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _vm.thumb == "bad"
                    ? _c("h4", [
                        _vm._v(
                          "\n          Tut uns leid, dass Sie mit WERNER unzufrieden sind. Bitte teilen Sie\n          uns mit was wir verbessern sollen.\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.thumb == "good"
                    ? _c("h4", [
                        _vm._v(
                          "\n          Schön, dass Sie mit WERNER zufrieden sind.\n        "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c(
                    "md-field",
                    { staticStyle: { margin: "10px" } },
                    [
                      _c("label", [_vm._v("Feedback")]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        model: {
                          value: _vm.textarea,
                          callback: function($$v) {
                            _vm.textarea = $$v
                          },
                          expression: "textarea"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function($event) {
                      _vm.writeFeedback = false
                    }
                  }
                },
                [_vm._v("Abbrechen")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function($event) {
                      return _vm.sendFeedback()
                    }
                  }
                },
                [_vm._v("Abschicken")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65325741", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65325741","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/navigation/Navigation.vue
// module id = null
// module chunks = 